import React from "react";
import RawIcons from "../../Icons/rawIcons";
import "./LayerPicker.scss";

/*
 * This component is the button that controls the layers on the map is visible
 */

const Layer = (props) => {
  return (
    <div
      style={
        !props.active
          ? {
              background: "rgba(111, 111, 111, 0.6)",
              fontWeight: 100,
            }
          : { background: "rgba(35, 35, 36, 0.9)" }
      }
      onClick={props.onClick}
      className={props.className}
    >
      {props.className === "layerPicker" && (
        <img
          className="pictogram"
          src={RawIcons[props.icon]}
          alt={`${props.icon} Icon`}
        />
      )}
      <p
        style={{
          userSelect: "none",
        }}
      >
        {props.text}
      </p>
    </div>
  );
};

export default Layer;
